import { StylesProvider as Provider, jssPreset } from '@material-ui/core/styles';
import { create } from 'jss';
import rtl from 'jss-rtl';

// configure JSS
// const jss = create({ plugins: [...jssPreset().plugins, rtl()] });
const jss = create({ plugins: [...jssPreset().plugins, rtl()] });



/**
 * @provider StylesProvider
 * @summary support for both rtl and ltr
 */
function StylesProvider(props) {
  return <Provider jss={jss}>{props.children}</Provider>;
}

export { StylesProvider };
